import { apiClient } from './axios';

import type {
  PaginatedResponse,
  AnalystReportRecord,
  AnalystReportQuery,
  CreateAnalystReportDto,
} from '@repo/shared-types';

export interface AnalystPreset {
  key: string;
  label: string;
  description: string;
  successLabel: string;
  failureLabel: string;
}

export const analyticsReporterApi = {
  getPresets: async () => {
    const response = await apiClient.get<AnalystPreset[]>('/analytics-reporter/presets');
    return response.data;
  },

  getReports: async (query: Partial<AnalystReportQuery> = {}) => {
    const response = await apiClient.get<PaginatedResponse<AnalystReportRecord>>(
      '/analytics-reporter',
      { params: query },
    );
    return response.data;
  },

  getReport: async (id: string) => {
    const response = await apiClient.get<AnalystReportRecord>(`/analytics-reporter/${id}`);
    return response.data;
  },

  createReport: async (data: CreateAnalystReportDto) => {
    const response = await apiClient.post<AnalystReportRecord>('/analytics-reporter', data);
    return response.data;
  },

  deleteReport: async (id: string) => {
    await apiClient.delete(`/analytics-reporter/${id}`);
  },
};
